(() => {
  function getEmbedUrl(url) {
    if (!url) return '';

    try {
      const parsed = new URL(url);
      const host = parsed.hostname.replace('www.', '');

      if (host === 'youtu.be') {
        const id = parsed.pathname.replace('/', '');
        return id ? `https://www.youtube.com/embed/${id}?autoplay=1&rel=0` : url;
      }

      if (host.includes('youtube.com')) {
        const id = parsed.searchParams.get('v');
        return id ? `https://www.youtube.com/embed/${id}?autoplay=1&rel=0` : url;
      }

      if (host.includes('vimeo.com')) {
        const id = parsed.pathname.split('/').filter(Boolean).pop();
        return id ? `https://player.vimeo.com/video/${id}?autoplay=1` : url;
      }

      return url;
    } catch (error) {
      return url;
    }
  }

  function initVideoCarousel(section) {
    if (!section || section.dataset.vrcReady === 'true') return;

    const viewport = section.querySelector('[data-vrc-viewport]');
    const track = section.querySelector('[data-vrc-track]');
    const progressFill = section.querySelector('[data-vrc-progress-fill]');
    const prevButton = section.querySelector('[data-vrc-prev]');
    const nextButton = section.querySelector('[data-vrc-next]');
    const modal = section.querySelector('[data-vrc-modal]');
    const iframe = section.querySelector('[data-vrc-iframe]');
    const closeButtons = section.querySelectorAll('[data-vrc-close]');
    const videoLinks = section.querySelectorAll('[data-vrc-video-link]');

    if (!viewport || !track || !progressFill || !prevButton || !nextButton) return;

    const getStep = () => {
      const card = track.querySelector('.video-review-carousel__card');
      if (!card) return viewport.clientWidth * 0.9;

      const cardStyles = window.getComputedStyle(track);
      const gap = Number.parseFloat(cardStyles.columnGap || cardStyles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    };

    const updateUi = () => {
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const ratio = maxScroll > 0 ? viewport.scrollLeft / maxScroll : 0;
      const visibleRatio = viewport.scrollWidth > 0 ? viewport.clientWidth / viewport.scrollWidth : 1;
      const fillWidth = Math.max(10, Math.min(100, visibleRatio * 100));
      const fillOffset = ratio * (100 - fillWidth);

      progressFill.style.width = `${fillWidth}%`;
      progressFill.style.transform = `translateX(${fillOffset}%)`;

      prevButton.disabled = viewport.scrollLeft <= 1;
      nextButton.disabled = viewport.scrollLeft >= maxScroll - 1;
    };

    const scrollByStep = (direction) => {
      viewport.scrollBy({ left: getStep() * direction, behavior: 'smooth' });
    };

    prevButton.addEventListener('click', () => scrollByStep(-1));
    nextButton.addEventListener('click', () => scrollByStep(1));
    viewport.addEventListener('scroll', updateUi, { passive: true });
    window.addEventListener('resize', updateUi);

    const closeModal = () => {
      if (!modal || !iframe) return;
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      iframe.src = '';
    };

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeModal);
    });

    videoLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        const url = link.dataset.videoUrl;
        if (!url) return;

        const embedUrl = getEmbedUrl(url);
        if (!embedUrl || !modal || !iframe) return;

        event.preventDefault();
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        iframe.src = embedUrl;
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal && !modal.hidden) {
        closeModal();
      }
    });

    updateUi();
    section.dataset.vrcReady = 'true';
  }

  function initAllCarousels(root = document) {
    root.querySelectorAll('[data-video-review-carousel]').forEach(initVideoCarousel);
  }

  document.addEventListener('DOMContentLoaded', () => initAllCarousels());
  document.addEventListener('shopify:section:load', (event) => initAllCarousels(event.target));
})();
